export default __webpack_public_path__ + "static/media/ChefsFavorite.40f4b2cd.jpg";